import type { ValueOf } from "@p-ban/common/src/types"

import definition from "./definition"

type DisplayName<T> = T extends (...args: any) => any ? (...args: Parameters<T>) => string : () => string
type EstimateFields = {
  [Key in keyof typeof definition]: Readonly<{
    key: Key
    type: (typeof definition)[Key]["type"]
    displayName: DisplayName<(typeof definition)[Key]["displayName"]>
  }>
}

// TODO 1-Click見積での表示名も扱えるようにする
const createEstimateField = (): EstimateFields => {
  const estimateField = {} as EstimateFields

  for (const [key, { type, displayName }] of Object.entries(definition)) {
    // 型の解決が難しいので仕方なくanyにして代入してます。
    ;(estimateField as any)[key] = {
      key,
      type,
      displayName: typeof displayName === "string" ? () => displayName : displayName,
    }
  }

  return estimateField
}

const estimateField = createEstimateField()

export default estimateField

export type EstimateFieldOf<T extends ValueOf<typeof estimateField>["type"]> = Extract<
  ValueOf<typeof estimateField>,
  { type: T }
>["key"]

export const isBooleanField = (field: keyof typeof estimateField): field is EstimateFieldOf<"boolean"> => {
  return estimateField[field].type === "boolean"
}

export const isNumberField = (field: keyof typeof estimateField): field is EstimateFieldOf<"number"> => {
  return estimateField[field].type === "number"
}

export const isDateField = (field: keyof typeof estimateField): field is EstimateFieldOf<"date"> => {
  return estimateField[field].type === "date"
}

export const isRadioField = (field: keyof typeof estimateField): field is EstimateFieldOf<"radio"> => {
  return estimateField[field].type === "radio"
}
